module.exports = __webpack_public_path__ + "img/check-glyph.22fdfb73.svg";